<template>
  <div 
    class="buttons-wrap"
    :class="{'quiz-wrap' : type === 'double'}"
  >
    <div v-if="type === 'double'">
      <p class="choose--text">{{
        $i18n.locale === 'it' ?
        "Scegli un'opzione:"
        :
        "Choose an option:"
      }}</p>
    </div>
    <div class="buttons-col">
      <ChatButton 
        v-for="(button,index) in buttons" 
        :key="index" 
        :type="type" 
        :text="button.text" 
        :action="action"
        :isCorrect="button.isCorrect != undefined ? button.isCorrect : null"
      />
    </div>
  </div>
</template>

<script>

import ChatButton from '@/components/ChatButton.vue'

export default {
  name: 'ButtonsWrap',
  props: ['type', 'buttonsArray', 'action'],
  components: {
    ChatButton
  },
  data(){
    return{
      buttons: []
    }
  },
  mounted(){
    var i = 0;

    let buttonInterval = setInterval(() => {
          
      if(i >= this.buttonsArray.length) {
        clearInterval(buttonInterval);
        
        return false
      };

      this.buttons.push(this.buttonsArray[i]);
      i++;

    }, 500);
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .buttons-wrap{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .choose--text{
    padding: 20px 0;
  }
  .buttons-col{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    @media screen and (max-width: 767px){
      flex-direction: column;
    }
  }
</style>
